import React from "react";

// right now only used in form components
// may need to be renamed if you create a PageHeader
export default function Header({ children }) {
  return <h3 className="text-2xl mt-2 mb-6">{children}</h3>;
}
